import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './DrawerEmptyState.module.scss'

const DrawerEmptyState = ({
  icon = 'inbox',
  text,
  subtext,
  className = ''
}) => {
  return (
    <Box className={`${styles.emptyState} ${className}`}>
      <Box className={styles.emptyStateIcon}>
        {typeof icon === 'string' ? <FontAwesomeIcon icon={icon} /> : icon}
      </Box>
      <Typography className={styles.emptyStateText}>
        {text}
      </Typography>
      {subtext && (
        <Typography className={styles.emptyStateSubtext}>
          {subtext}
        </Typography>
      )}
    </Box>
  )
}

DrawerEmptyState.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  text: PropTypes.node.isRequired,
  subtext: PropTypes.node,
  className: PropTypes.string
}

export default DrawerEmptyState
